import { fetchApi } from '../api/userProfileManager';
export default async (params = {}, logger) => {
    const filter = params.filter ? [...new Set(params.filter)].join(',') : undefined;
    return fetchApi({ ...params, filter }, `profile/{userId}`, logger);
};
